export default __webpack_public_path__ + "static/media/button_kikan-MONTH.5aadc1b0.PNG";